import ReactExport from "react-export-excel";
import React from "react";
import { Dropdown } from "react-bootstrap";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const ProfitBreakdownExcelToRenderOverallComponent = (
  data,
  filename
) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Gross Income Breakdown">
      <ExcelColumn label="Cluster Name" value={(r) => r.clusterName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}

      <ExcelColumn
        label="Charges"
        value={(r) =>
          r.newPawnDetails.charges.length > 0
            ? `New:\n${r.newPawnDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Charges"
        }
      />

      <ExcelColumn
        label="Discounts"
        value={(r) =>
          r.newPawnDetails.discounts.length > 0
            ? `New:\n${r.newPawnDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Discounts"
        }
      />

      <ExcelColumn label="Profit Pawn" value={(r) => r.newPawnDetails.profit} />
      <ExcelColumn
        label="Profit Redeem"
        value={(r) => r.redeemedDetails.profit}
      />
      <ExcelColumn label="Profit Total" value={(r) => r.totalProfit} />
    </ExcelSheet>
  </ExcelFile>
);

export const ProfitBreakdownExcelToRenderAreaComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Profit breakdown">
      <ExcelColumn label="Area Name" value={(r) => r.areaName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}

      <ExcelColumn
        label="Charges"
        value={(r) =>
          r.newPawnDetails.charges.length > 0
            ? `New:\n${r.newPawnDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Charges"
        }
      />
      <ExcelColumn
        label="Discounts"
        value={(r) =>
          r.newPawnDetails.discounts.length > 0
            ? `New:\n${r.newPawnDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Discounts"
        }
      />

      <ExcelColumn label="Profit Pawn" value={(r) => r.newPawnDetails.profit} />
      <ExcelColumn
        label="Profit Redeem"
        value={(r) => r.redeemedDetails.profit}
      />
      <ExcelColumn label="Profit Total" value={(r) => r.totalProfit} />
    </ExcelSheet>
  </ExcelFile>
);

export const ProfitBreakdownExcelToRenderBranchComponent = (data, filename) => (
  <ExcelFile filename={filename} element={<Dropdown.Item>Excel</Dropdown.Item>}>
    <ExcelSheet data={data} name="Daily Report">
      <ExcelColumn label="Branch Code" value={(r) => r.branchCode} />
      <ExcelColumn label="Branch Name" value={(r) => r.branchName} />
      {/* <ExcelColumn label="# of Branches" value={(r) => r.branchCount} /> */}

      <ExcelColumn
        label="Charges"
        value={(r) =>
          r.newPawnDetails.charges.length > 0
            ? `New:\n${r.newPawnDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.charges
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Charges"
        }
      />
      <ExcelColumn
        label="Discounts"
        value={(r) =>
          r.newPawnDetails.discounts.length > 0
            ? `New:\n${r.newPawnDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}\nRedeemed:\n${r.redeemedDetails.discounts
                .map((ch) => {
                  return `${ch.name} : ${ch.amount}`;
                })
                .join(", \n")}`
            : "No Discounts"
        }
      />

      <ExcelColumn label="Profit Pawn" value={(r) => r.newPawnDetails.profit} />
      <ExcelColumn
        label="Profit Redeem"
        value={(r) => r.redeemedDetails.profit}
      />
      <ExcelColumn label="Profit Total" value={(r) => r.totalProfit} />
    </ExcelSheet>
  </ExcelFile>
);
